<template>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center vertical">
      <div class="col-lg-6 col-xl-5">
        <h1>Login</h1>

        <div class="box">
          <b-form @submit.prevent="submit">
            <b-form-group
              label="Email Address"
              :invalid-feedback="errors.email ? errors.email[0] : ''"
              :state="errors.email ? false : null"
            >
              <b-form-input
                name="email" type="email"
                required trim autocomplete="username"
                v-model="email"
                :state="errors.email ? false : null"
                :disabled="loading"
              />
            </b-form-group>

            <b-form-group
              label="Password"
              :state="errors.email ? false : null"
            >
              <b-form-input
                name="password" type="password"
                required trim autocomplete="password"
                v-model="password"
                :state="errors.email ? false : null"
                :disabled="loading"
              />
            </b-form-group>

            <div class="row">
              <div class="col-md-6 left-then-center order-md-1 order-2 mt-4">
                <router-link class="btn btn-xs pl-0 pr-0" to="/forgot-password">
                  Forgot Password?
                </router-link>
              </div>

              <div class="col-md-6 order-1">
                <b-btn type="submit" variant="secondary" size="lg" block>
                  Log In
                </b-btn>
              </div>
            </div>
          </b-form>
        </div>

        <h1>Sign Up</h1>

        <b-btn class="btn-highlight" size="lg" block to="/register">
          Sign Up For An Account
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLogin',
  data () {
    return {
      email: '',
      password: '',
      errors: {},
      loading: false
    }
  },
  mounted: function () {
    // if (process.env.NODE_ENV !== 'production') {
    //   this.email = 'matt+fivenomicsadvisor@builtbybackspace.com'
    //   this.password = '@4fP8nR5Z0fp'
    // }
  },
  methods: {
    submit () {
      const storageRedirect = sessionStorage.getItem('loginRedirectPath')
      const redirect = storageRedirect != null ? storageRedirect : '/dashboard'
      // Make sure to remove the redirect, so it doesn't bother users in the future
      // eslint-disable-next-line
      // console.log(redirect)
      sessionStorage.removeItem('loginRedirectPath')
      this.$auth.login({
        data: { email: this.email, password: this.password },
        error: (err) => {
          this.errors = err.response.data.errors || {
            email: [ 'Please check your email or password and try again!' ]
          }
        },
        redirect: redirect,
        fetchUser: true
      })
    }
  }
}
</script>
